import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.funkprotokoll-vorlage-anlegen-admin';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenFunkprotokollVorlageAnlegenAdminEffects {

    FunkprotokollVorlageAnlegenAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_FUNKPROTOKOLL_VORLAGE_ANLEGEN_ADMIN),
        mergeMap((x: ac.PostFunkprotokollVorlageAnlegenAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postFunkprotokollVorlageAnlegenAdmin(x.funkprotokollVorlageDatenRequest).pipe(
                map((result: any) => {
                    return new ac.PostFunkprotokollVorlageAnlegenAdminErfolgreichAction(result, x.funkprotokollVorlageDatenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostFunkprotokollVorlageAnlegenAdminFehlerAction(error, x.funkprotokollVorlageDatenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunkprotokollVorlageCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunkprotokollVorlageCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunkprotokollVorlageCommandService);
        }
        return this.service;
    }
}
